import { useCallback, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { usePageStartBootstrap } from '../hooks/use_page_start_bootstrap';
import { processError } from '../utils/base_error';
import { useDependencyInjection } from '../../config/di/dependency_injection_context';
import { usePageLoader } from '../contexts/page_content_context';
import { CargoDropDown } from '../domain/models/cargo_dropdown';

type Props = {
  name: string;
  label?: string;
  newButtonLabel?: string;
  required?: boolean;
  readOnly?: boolean;
  placeholder?: string;
  disabled?: boolean;
  value: string | number | null | undefined; 
  onChange: (newValue: string | number | undefined) => void; 
  error?: boolean;
  helperText?: string | null;
};

export const DefaultCargos = ({
  name,
  label,
  required,
  readOnly,
  placeholder,
  disabled,
  value,
  onChange,
  error,
  helperText,
}: Props) => {

  const { pushErrorNotification, pushInfoNotification } = usePageLoader();
  const [cargoDropDown, setCargoDropDown] = useState<CargoDropDown[]>([]);

  const {
    commons: {
      getCargosDropDownUseCase,
    },
  } = useDependencyInjection();

  const loadContratoDropDown = useCallback(async () => {
    try {
      const result = await getCargosDropDownUseCase.getCargosDropDown();
      setCargoDropDown(result);
    } catch (e: unknown) {
      pushErrorNotification('Error', processError(e, 'Falha ao buscar cargos!'));
    }
  }, [getCargosDropDownUseCase, pushErrorNotification]);

  usePageStartBootstrap(async () => {
    loadContratoDropDown();
  });


  return (
    <>
     <Autocomplete
        fullWidth={true}
        size="small"
        disablePortal
        options={cargoDropDown}
        getOptionLabel={(opt) => String(opt.descricao)}
        isOptionEqualToValue={(opt, val) => String(opt.descricao) === String(val.descricao)} 
        sx={{ minHeight: 45 }}
        readOnly={readOnly}
        disabled={disabled}
        value={cargoDropDown.find(x => String(x.idCargo) === String(value)) ?? null}
        onChange={(_, newValue) => {
          onChange(newValue ? newValue.idCargo : undefined);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label={label}
            error={error}
            helperText={helperText}
            placeholder={placeholder}
            required={required}
          />
        )}
      />
    </>
  );
};